import { userTypesList } from './constants';
import { log } from '../utility';
import { filterSlots } from './filterSlots';
import pubtechSlots from './data/adv_slots_by_pubtech.json';
import { getTestata } from '../paywall/lib/utils';

const testataQn = (getTestata() === 'qn');

const DIV_ID_PREFIX = 'div-gpt-ad-';

const slotsAds = [];
let pubtechSlotsUnits = [];
if(testataQn) {
  pubtechSlotsUnits = pubtechSlots.map(slotName => DIV_ID_PREFIX + slotName.unit)
}

function executeTask(cmd) {
  if (typeof cmd === 'function') {
    cmd();
  }
}

function loadGPTScript() {
  const tag = document.createElement('script');
  tag.type = 'text/javascript';
  tag.src = 'https://www.googletagservices.com/tag/js/gpt.js';
  const node = document.getElementsByTagName('script')[0];
  node.parentNode.insertBefore(tag, node);
  window.googletag = window.googletag || { cmd: [] };
}

function defineSlot(slot, sizes, divId, outOfPage, isPubtechEnabled) {
  log('Add GPT definition for', slot);
  const googletag = window.googletag;
  if (outOfPage) {
    googletag.cmd.push(function () {
      if(testataQn && isPubtechEnabled) {
       // pubtech_slots[slot] = googletag.defineOutOfPageSlot(slot, divId).addService(googletag.pubads()); // pubtech
      } else {
        slotsAds[slot] = googletag.defineOutOfPageSlot(slot, divId).addService(googletag.pubads());
      }
      // log('GPT defined', slot);
    });
  } else {
    googletag.cmd.push(function () {
      if(testataQn && isPubtechEnabled) {
        // pubtech_slots[slot] = googletag.defineSlot(slot, sizes, divId).addService(googletag.pubads()); // pubtech
      } else {
        slotsAds[slot] = googletag.defineSlot(slot, sizes, divId).addService(googletag.pubads());
      }
      // log('GPT defined', slot);
    });
  }
}

function enableServices(isPubtechEnabled) {
  const googletag = window.googletag;
  googletag.cmd.push(function () {

    if(!testataQn && !isPubtechEnabled) {
      googletag.pubads().enableLazyLoad();
    }

    googletag.pubads().enableSingleRequest();
    // collapsing empty divs raises CLS
    googletag.pubads().collapseEmptyDivs();

    if(testataQn && isPubtechEnabled) {
      googletag.pubads().disableInitialLoad(); // Pubtech
    }

    googletag.pubads().setCentering(true);
    googletag.enableServices();
  });
}

function setPageTargeting() {
  const googletag = window.googletag;
  const pcp = window.pcp;
  const targetingDict = pcp.MonrifPolopolyUtility.TagManager || {};
  targetingDict.device = pcp.device;
  if (pcp.thirdLevelDomain) targetingDict.site = pcp.thirdLevelDomain;
  googletag.cmd.push(function () {
    for (const key in targetingDict) googletag.pubads().setTargeting(key, targetingDict[key]);
  });
}

function getSlotOptions(slotName, advSlotList) {
  for (let i = 0; i < advSlotList.length; i++) {
    if (advSlotList[i].unit === slotName) {
      return advSlotList[i];
    }
  }
}

function init(slots, isPubtechEnabled) {
  window.pcp = {
    define: function (path, positions, device) {
      log(path, positions);
      log('Device', device);
      const pcp = window.pcp;
      pcp.device = device;
      if ('globals' in window) {
        pcp.thirdLevelDomain = window.globals.customDomain;
      }
      pcp.MonrifPolopolyUtility = window.MonrifPolopolyUtility || {};
      log('Load GPT');
      loadGPTScript();
      pcp.__defined = [];
      for (let i = 0; i < positions.length; i++) {
        const slotName = positions[i];

        let isPubTechManaged = false;
        if(testataQn && isPubtechEnabled) {
          isPubTechManaged = isPubtechEnabled && pubtechSlotsUnits.includes(`${DIV_ID_PREFIX}${slotName}`); // Pubtech
        }

        const slotOptions = getSlotOptions(slotName, slots);
        if (slotOptions) {
          if (slotOptions.device !== pcp.device) {
            continue;
          }
          let adUnitPath = path;
          if ('custom_adunit_dir' in slotOptions && slotOptions.custom_adunit_dir !== '') {
            const speedConf = (pcp.MonrifPolopolyUtility.aggregatorValues || {}).speed || {};
            adUnitPath = speedConf.code || '';
            adUnitPath += slotOptions.custom_adunit_dir.replace(/\{[^}]+\}/gi, function (m) {
              const key = m.substring(1, m.length - 1).toLowerCase();
              if (key in speedConf) return speedConf[key];
              return '';
            });
            if (!adUnitPath.match(/\/$/)) adUnitPath += '/';
          }
          adUnitPath += positions[i];
          if(!isPubTechManaged) {
            defineSlot(
              adUnitPath,
              slotOptions.sizes,
              DIV_ID_PREFIX + slotName,
              slotOptions.outOfPage,
              isPubtechEnabled
            );
            pcp.__defined.push(DIV_ID_PREFIX + slotName);
          }
        } else {
          console.warn(slotName, 'not defined');
        }
      }
      setPageTargeting();
      if(testataQn && isPubtechEnabled) {
        enableServices(isPubtechEnabled); // Pubtech
      } else {
        enableServices()
      }
    },
    push: function (cmd) {
      executeTask(cmd);
    },
    display: function (divId) {
      const pcp = window.pcp;
      if (pcp.__defined.indexOf(divId) === -1) {
        log(divId, 'not defined');
        return;
      }

      let isPubTechManaged = testataQn && isPubtechEnabled && pubtechSlotsUnits.includes(divId);
      if(testataQn && isPubtechEnabled && isPubTechManaged) {
        isPubTechManaged = 
        log(divId, 'pubtech managed');
          return;
      }

      window.googletag.cmd.push(function () {
        window.googletag.display(divId);
        if(!isPubTechManaged) { // Pubtech
          window.googletag.pubads().refresh([slotsAds[divId]]);
        }
      });
    },
  };
  for (let i = 0; i < pending.length; i++) {
    executeTask(pending[i]);
  }
}

window.pcp = window.pcp || [];
const pending = window.pcp;
log('Pending tasks', pending);

window.requireConsent = window.requireConsent || [];

export const pcp2Init = (userType) => {
  const { globals = {} } = window;
  const isPubtechEnabled = globals.isPubtechEnabled;

  const slots = filterSlots(userTypesList, userType, globals.isArticle, globals.isMobile);
  init(slots, isPubtechEnabled);
};
